import { EntityAdapter, EntityState, createEntityAdapter } from '@ngrx/entity'
import { Action, createReducer, on } from '@ngrx/store'

import * as SiteAnnouncementsActions from './site-announcements.actions'
import { SiteAnnouncementsEntity } from './site-announcements.models'

export const SITE_ANNOUNCEMENTS_FEATURE_KEY = 'siteAnnouncements'

export interface SiteAnnouncementsState extends EntityState<SiteAnnouncementsEntity> {
  selectedId?: string | number
  loaded: boolean
  unreadAnnouncements: SiteAnnouncementsEntity[]
  editCreateLoaded: boolean
}

export interface SiteAnnouncementsPartialState {
  readonly [SITE_ANNOUNCEMENTS_FEATURE_KEY]: SiteAnnouncementsState
}

export const siteAnnouncementsAdapter: EntityAdapter<SiteAnnouncementsEntity> =
  createEntityAdapter<SiteAnnouncementsEntity>({
    selectId: (siteAnnouncementsEntity: SiteAnnouncementsEntity) => siteAnnouncementsEntity.uuid,
  })

export const initialSiteAnnouncementsState: SiteAnnouncementsState = siteAnnouncementsAdapter.getInitialState({
  loaded: false,
  unreadAnnouncements: [],
  editCreateLoaded: true,
})

const reducer = createReducer(
  initialSiteAnnouncementsState,
  on(SiteAnnouncementsActions.loadSiteAnnouncements, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(SiteAnnouncementsActions.loadSiteAnnouncementsSuccess, (state, { site_announcements }) =>
    siteAnnouncementsAdapter.setAll(site_announcements, {
      ...state,
      loaded: true,
    }),
  ),
  on(SiteAnnouncementsActions.loadSiteAnnouncementsFailure, (state, { error }) => ({
    ...state,
    error,
  })),
  on(SiteAnnouncementsActions.createSiteAnnouncementSuccess, (state, action) =>
    siteAnnouncementsAdapter.addOne(action.site_announcement, state),
  ),
  on(SiteAnnouncementsActions.updateSiteAnnouncementSuccess, (state, action) =>
    siteAnnouncementsAdapter.updateOne(action.update, state),
  ),
  on(SiteAnnouncementsActions.deleteSiteAnnouncementSuccess, (state, action) =>
    siteAnnouncementsAdapter.removeOne(action.uuid, state),
  ),
  on(SiteAnnouncementsActions.selectSiteAnnouncement, (state, { uuid }) => ({
    ...state,
    selectedId: uuid,
  })),
  on(SiteAnnouncementsActions.createSiteAnnouncement, SiteAnnouncementsActions.updateSiteAnnouncement, (state) => ({
    ...state,
    editCreateLoaded: false,
  })),
  on(
    SiteAnnouncementsActions.createSiteAnnouncementSuccess,
    SiteAnnouncementsActions.createSiteAnnouncementFailure,
    SiteAnnouncementsActions.updateSiteAnnouncementFailure,
    SiteAnnouncementsActions.updateSiteAnnouncementSuccess,
    (state) => ({ ...state, editCreateLoaded: true }),
  ),
)

export function siteAnnouncementsReducer(state: SiteAnnouncementsState | undefined, action: Action) {
  return reducer(state, action)
}
